<template>
	<baseContent :onlyIcon="true">
		<div class="width-1280 study">
			<el-row :gutter="20">
				<el-col :span="16">
					<div class="study-left bg-fff">
						<div class="study-title col-333 bold">电子商务在线营销技能证书</div>
						<div class="study-video">
							<video :src="require('@/assets/video/2.mp4')" style="height: 100%;width: 100%;object-fit: cover" controls></video>
						</div>
					</div>
				</el-col>
				<el-col :span="8">
					<div class="study-synopsis bg-fff">
						<div class="synopsis-title over-2 col-333 f16">
							电子商务在线营销职业技能证书通常涵盖广泛的主题，包括数字营销、社交媒体…
						</div>
						<div class="synopsis-list">
							<div class="synopsis-item flex align-c" v-for="(item,index) in accordionList" :key="index" @click="playChange(item,index)" :class="playIndex == index ? 'synopsis-active' : ''">
								<el-image class="item-play"
									:src="playIndex == index ? playYes : playNo"></el-image>
								<div class="bold synopsis-text" :class="playIndex == index ? 'col-169' : 'col-333'">{{item.title}}</div>
							</div>
						</div>
					</div>
					<div class="mt-20 recommend bg-fff">
						<div class="recommend-head flex align-c col-333 bold f16">相关技能推荐</div>
						<div class="recommend-item f16 bold col-333" v-for="(item,index) in recommendList" :key="index">
							{{item.name}}
						</div>
						<div class="recommend-more flex align-c justify-c col-169">查看更多</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</baseContent>
</template>

<script>
	import baseContent from '@/components/base-content.vue'
	export default{
		components:{ baseContent },
		data(){
			return{
				playYes:require('@/assets/images/course/play@2x.png'),
				playNo:require('@/assets/images/course/play-w@2x.png'),
				accordionList:[
					{
						title:'第一部分 课程导入',
						sub:'',
						lv:3
					},
					{
						title:'第二部分 数字营销基础',
						sub:'',
						lv:3
					},
					{
						title:'第三部分 电子商务战略',
						sub:'',
						lv:3
					},
					{
						title:'第四部分 社交媒体管理',
						sub:'',
						lv:2
					},
					{
						title:'第五部分 内容营销管理',
						sub:'',
						lv:2
					},
					{
						title:'第六部分 搜索引擎优化',
						sub:'',
						lv:2
					},
					{
						title:'第七部分 搜索引擎广告',
						sub:'',
						lv:1
					},
					{
						title:'第八部分 电子邮件营销',
						sub:'',
						lv:1
					},
					{
						title:'第九部分 数据分析和报告',
						sub:'',
						lv:1
					},
					{
						title:'第十部分 营销优化',
						sub:'',
						lv:0
					},
					{
						title:'第十一部分 用户行为分析',
						sub:'',
						lv:0
					}
				],
				playIndex:0,
				recommendList:[
					{name:'用户体验设计交互技能证书'},
					{name:'产品需求管理分析技能证书'},
					{name:'产品管理用户体验设计职业技能证书'},
					{name:'用户体验设计交互技能证书'},
					{name:'项目管理用户方向技能证书'},
				]
			}
		},
		mounted() {
			this.playIndex = this.$route.query.index || 0
		},
		methods:{
			playChange(item,index){
				this.playIndex = index
			}
		}
	}
</script>

<style>
	.study{
		padding: 24px 20px;
	}
	.study-left{
		border-radius: 12px;
		padding: 32px 10px 0 10px;
		height: 944px;
	}
	.study-title{
		font-size: 32px;
		line-height: 45px;
	}
	.study-video{
		margin-top: 32px;
		height: 727px;
	}
	.study-synopsis{
		height: 562px;
		overflow: hidden;
		border-radius: 12px;
	}
	.synopsis-title{
		padding: 20px;
		height: 84px;
		background: #F1F9FD;
		margin-bottom: 16px;
	}
	.f16{
		font-size: 16px;
		line-height: 22px;
	}
	.synopsis-list{
		height: 446px;
		overflow-y: scroll;
	}
	.synopsis-list::-webkit-scrollbar{
		display: none;
	}
	.synopsis-active{
		background: rgba(22,155,213,0.06);
	}
	.synopsis-item{
		padding: 0 20px;
		height: 50px;
		margin-top: 4px;
		cursor: pointer;
	}
	.synopsis-item:hover .synopsis-text{
		color: #169BD5;
	}
	.item-play{
		width: 24px;
		height: 15px;
		margin-right: 10px;
	}
	.synopsis-text{
		font-size: 16px;
		line-height: 22px;
	}
	.col-169{
		color: #169BD5;
	}
	.recommend{
		overflow: hidden;
		border-radius: 12px;
		padding-bottom: 20px;
	}
	.recommend-head{
		height: 50px;
		background: #F1F9FD;
		padding-left: 20px;
	}
	.recommend-item{
		padding-left: 20px;
		margin-top: 20px;
	}
	.recommend-more{
		width: 154px;
		height: 40px;
		border-radius: 8px;
		border: 1px solid #169BD5;
		margin: auto;
		margin-top: 26px;
	}
</style>